export default {
  bind(el) {
    el.addEventListener('input', (event) => {
      const input = event.target;
      const filteredValue = input.value.replace(/[^a-zA-Z0-9]/g, '');
      if (input.value !== filteredValue) {
        input.value = filteredValue;
        input.dispatchEvent(new Event('input'));
      }
    });
  }
};
